
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/fix",
      function () {
        return require("private-next-pages/fix/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/fix"])
      });
    }
  